const _products = [
  {
    id: 25,
    title: "Revista MADRIGAL, Iunie 2025 | Numărul 5 | „Spectacolul Madrigal”",
    artist: "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
    editor: "Monica Lup", 
    description: [
      "Revista MADRIGAL este publicația culturală trimestrială editată de Corul Național de Cameră „Madrigal - Marin Constantin”, cu peste 240 de pagini de cronici, interviuri și cele mai noi informații din domeniul artelor spectacolului din România.",
      "Revista MADRIGAL | Iunie 2025 | Numărul 5 | „Spectacolul Madrigal” ISSN 3045 - 2554 ISSN - L - 2554",
      "*",
      "Redactor-șef: Monica Lup",
      "Redactori: Gabriela Bejan, Ioana Bîgu, Larisa Clempuș, Ștefan Costache, Silvana Dulamă-Popa, Ariadna Ene-Iliescu, Mădălin Guruianu, Andreea Kiseleff-Ignat, Carmen Macavei, Ioana Marghita, Alina Marin, Andrei Mărgulescu, Andrei Platon, Ilinca Straton, Ioana Țintea, Irina Vasilescu, Ana Carmen Dragoș",
      "Invitat: compozitorul Andrei Petrache",
      "Art Director: Alexandru Marinescu",
      "Tehnoredactare: Andreea Barbu, Iustina Soare",
      "Corectură: Victoria Violeta Popa",
      "Foto: Teodora Ungureanu",
      "Director distribuție: Ana Carmen Dragoș",
      "Coordonator print: Mihaela Toader",
      "Tipar: Compania Națională a Imprimeriilor „Coresi”",
      "Publisher: Leila Popovici",
      "Director executiv: Emil Pantelimon",
      "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
      "*",
      "* Costul de transport prin curier este suportat de destinatar. Detalii, în formularul de comandă.",
    ],
    image: "revista-madrigal-05.jpg",
    price: 0,
  },
  {
    id: 24,
    title: "Revista MADRIGAL, Aprilie 2025 | Numărul 4 | „Centenar Marin Constantin”",
    artist: "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
    editor: "Monica Lup", 
    description: [
      "Revista MADRIGAL este publicația culturală trimestrială editată de Corul Național de Cameră „Madrigal - Marin Constantin” - peste 240 de pagini de cronici, interviuri și cele mai noi informații din domeniul artelor spectacolului din România.",
      "Revista MADRIGAL | Aprilie 2025 | Numărul 4 | „Centenar Marin Constantin” ISSN 3045 - 2554 ISSN - L - 2554",
      "*",
      "Redactor-șef: Monica Lup",
      "Redactori: Anca Ioana Andriescu, Valentina Băințan, Ioana Bîgu, Vladimir Bulat, Larisa Clempuș, Ariadna Ene-Iliescu, Teodora Ion, Silvana Dulamă-Popa, Angelica Postu, Miruna Prisacariu, Ana Rubeli, Ana Sireteanu, Irina Cristina Vasilescu",
      "Invitați: conf. univ. dr. Diana Dembinski-Vodă, conf. univ. dr. Grigore Cudalbu",
      "Art Director: Alexandru Marinescu",
      "Tehnoredactare: Andreea Barbu, Iustina Soare",
      "Corectură: Victoria Violeta Popa",
      "Foto: Teodora Ungureanu",
      "Director distribuție: Ana Carmen Dragoș",
      "Coordonator print: Mihaela Toader",
      "Tipar: Compania Națională a Imprimeriilor „Coresi”",
      "Publisher: Leila Popovici",
      "Director executiv: Emil Pantelimon",
      "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
      "*",
      "* Costul de transport prin curier este suportat de destinatar. Detalii, în formularul de comandă.",
    ],
    image: "revista-madrigal-04.jpg",
    price: 0,
  },
  {
    id: 23,
    title: "Revista MADRIGAL, Ianuarie 2025 | Numărul 3 | „Punct și de la cap”",
    artist: "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
    editor: "Monica Lup", 
    description: [
      "Revista MADRIGAL este publicația culturală trimestrială editată de Corul Național de Cameră „Madrigal - Marin Constantin”. Peste 240 de pagini de cronici, interviuri și cele mai noi informații din domeniul artelor spectacolului din România.",
      "Revista MADRIGAL | Ianuarie 2025 | Numărul 3 | „Punct și de la cap” ISSN 3045 - 2554 ISSN - L - 2554",
      "Din cuprins: Corul Madrigal, mesager al muzicii românești în SUA | Interviu cu Excelența Sa, domnul Dan-Andrei Muraru, Ambasador Extraordinar și Plenipotențiar al României în Statele Unite ale Americii | Visul European | Punți peste Europa - o poveste a armoniei europene | Lecțiile Matildei | Punct și de la capăt",
      "*",
      "Redactor-șef: Monica Lup",
      "Redactori: Ioana Bîgu, Irina Brădeanu-Alexandru, Larisa Clempuș, Mădălin Guruianu, Andreea Kiseleff-Ignat, Carmen Macavei, Andreea Mărgărit, Raluca Mocanu, Marina Nedelcu, Marcel Platon, Daria Sarchizian, Ana Sireteanu, Ioana Țintea, Irina Cristina Vasilescu",
      "Invitați: prof. univ. dr Doina Rotaru, prof. univ. dr. Christian-Alexandru Petrescu",
      "Art Director: Marius Portik",
      "Tehnoredactare: Alexandru Marinescu, Andreea Barbu",
      "Corectură: Victoria Popa",
      "Foto: Teodora Ungureanu",
      "Multimedia: Cătălin Alexandru, Timoteea Gabor, Andrei Țoneș, Zsolt Portik",
      "Director distribuție: Ana Carmen Dragoș",
      "Coordonator print: Mihaela Toader",
      "Tipar: Compania Națională a Imprimeriilor „Coresi”",
      "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
      "*",
      "* Costul de transport prin curier este suportat de destinatar. Detalii, în formularul de comandă.",
    ],
    image: "revista-madrigal-03.jpg",
    price: 0,
  },
  {
    id: 22,
    title: "Revista MADRIGAL, Octombrie 2024 | Numărul 2 | „Pe micul ecran”",
    artist: "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
    editor: "Monica Lup", 
    description: [
      "Revista MADRIGAL este publicația culturală trimestrială editată de Corul Național de Cameră „Madrigal - Marin Constantin”. Peste 240 de pagini de cronici, interviuri și cele mai noi informații din domeniul artelor spectacolului din România.",
      "Revista MADRIGAL | Octombrie 2024 | Numărul 2 | „Pe micul ecran” ISSN 3045 - 2554 ISSN - L - 2554",
      "Din cuprins: Madrigalul și arta cinematografică | Madrigal la Roma | Muzica unor filme arestate | Madrigalul în arhiva TVR | „Flăcări și roți” de Corneliu Cezar | Despre educația muzicală, altfel | Muzicanții vechiului București | Perspective ale corectitudinii politice în artă | Diplomație culturală | Apariții discografice 2024 | Istorii și ideologii | Dialog cultural | Magia cântului împreună | Bursele UNIMIR 2024 - 2025 | Atelierele Micul Artist | Madrigal la FITS",
      "*",
      "Redactor-șef: Monica Lup",
      "Redactori: Valentina Băințan, Ioana Bîgu, Larisa Clempuș, Petre Fugaciu, Nicolae Gheorghiță, Mădălin Guruianu, Andreea Mâniceanu, Marina Nedelcu, Olguța Lupu, Mihaela Radu, Ioana Țintea, Irina Vasilescu",
      "Art Director: Marius Portik",
      "Tehnoredactare: Alexandru Marinescu, Andreea Barbu",
      "Corectură: Ana Ciutu, Adina Iacob, Carmen Macavei, Virginia Tutoveanu, Teodora Ungureanu",
      "Foto: Teodora Ungureanu",
      "Director distribuție: Ana Carmen Dragoș",
      "Coordonator print: Mihaela Toader",
      "Tipar: Compania Națională a Imprimeriilor „Coresi”",
      "Publisher: Leila Popovici",
      "Director executiv: Emil Pantelimon",
      "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
      "*",
      "* Costul de transport prin curier este suportat de destinatar. Detalii, în formularul de comandă.",
    ],
    image: "revista-madrigal-02.jpg",
    price: 0,
  },
  {
    id: 21,
    title: "Revista MADRIGAL, Iunie 2024 | Numărul 1 | „Walk of Fame”",
    artist: "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
    editor: "Monica Lup", 
    description: [
      "Revista MADRIGAL este publicația culturală trimestrială editată de Corul Național de Cameră „Madrigal - Marin Constantin”. Peste 240 de pagini de cronici, interviuri și cele mai noi informații din domeniul artelor spectacolului din România.",
      "Primul număr al Revistei MADRIGAL a fost lansat pe 26 iunie 2024, în cadrul Bursei Internaționale a Spectacolelor de la Sibiu, într-o conferință moderată de profesorul și criticul de teatru Octavian Saiu.",
      "Revista MADRIGAL | Iunie 2024 | Numărul 1 | „Walk of Fame” ISSN 3045 - 2554 ISSN - L - 2554",
      "Din cuprins: Interviu cu Maestrul Ion Marin | FITS și Corul Madrigal leagă o #PrieteniePeViață | Interviu cu Excelența Sa, doamna Camelia Ion- Radu | În căutarea miracolului | Interviu cu actorul Constantin Chiriac | Despre noua scenografie a Corului Madrigal | Aula Palatului Patriarhiei | Walk of Fame Music | Madrigal Festival Baia Mare | Madrigal Festival Maramureș | Un model de bune practici la Opera Comică pentru Copii | Cantus Mundi | Percuție și suflători | Forumul Cantus Mundi | Omagiu copilăriei | „Misa Criolla” | School of Musical",
      "*",
      "Redactor-șef: Monica Lup",
      "Redactori: Valentina Băințan, Larisa Clempuș, Ștefan Costache, Mădălin Guruianu, Andreea Kiseleff, Carmen Macavei, Ioana Marghita, Ioana Țintea, Irina Cristina Vasilescu",
      "Art Director: Marius Portik",
      "Tehnoredactare: Andreea Barbu, Alexandru Marinescu",
      "Corectură: Adina Iacob",
      "Foto: Teodora Ungureanu, Diana Chitic, Iustina Soare",
      "Tipar: Compania Națională a Imprimeriilor „Coresi”",
      "Publisher: Emil Pantelimon",
      "Director executiv: Leila Popovici",
      "Revistă editată de Corul Naţional de Cameră „Madrigal – Marin Constantin”",
      "*",
      "* Costul de transport prin curier este suportat de destinatar. Detalii, în formularul de comandă.",
    ],
    image: "revista-madrigal-01.jpg",
    price: 0,
  },
  {
    id: 20,
    title: "Corul Madrigal în arhivele Securității. Rezistența prin colind",
    autor: "Monica Lup",
    editor: "Emil Pantelimon", 
    description: [
      "Volumul „Corul Madrigal în arhivele Securității. Rezistența prin colind” este semnat de muzicologa Monica Lup, cu o prefaţă de Emil Pantelimon, managerul Corului Național de Cameră „Madrigal – Marin Constantin”.",
      "Pe materiale de arhivă, interviuri și pe cercetări minuțioase întreprinse de Monica Lup la Consiliul Național de Studiere a Arhivelor Securității, cele 100 de pagini ale cărții surprind curajul și determinarea Madrigalului și a fondatorului său, Marin Constantin, de a scoate la lumină, interpreta și promova colindele românești și de a păstra vie spiritualitatea poporului român, într-una dintre cele mai cumplite perioade din istoria noastră.",
      "„În cele șase decenii de activitate continuă, Madrigalul a colecționat câteva aspecte ce îi conferă statut de simbol pentru ceea a însemnat rezistența culturală românească în perioada comunismului, și totodată renașterea, sub semnul tradiției și al înnoirii, caracteristică timpurilor post-revoluționare. Concentrându-se pe câteva zone repertoriale – muzica bizantină, madrigalele renascentiste și creațiile contemporane românești – cu anumite completări conjuncturale, Madrigalul și-a asociat în mod justificat eticheta de cel mai bun mesager al acestor teritorii stilistice, în perimetrul muzicii vocale și pentru scena românească de concert. Peste toate acestea, Madrigalul și-a pus semnătura pe binomul tradiție-emoție reprezentat de colind, gen ale cărui transformări au constituit un adevărat barometru al schimbărilor politice și culturale pe care România le-a traversat și pe care formația l-a abordat permanent în concerte și înregistrările sale încă din anul 1966..” – Monica Lup",
      "„MONICA LUP prezintă (...) dovezi de o valoare inestimabilă. Documentarea de față are subiect și predicat, și este realizată minuțios de un specialist, în condeiul căruia argumentul și sursa au reprezentat singura cale. Felul în care Monica Lup scotocește arhivele C.N.S.A.S. și sapă după date sau relatări ale martorilor direcți și obiectivitatea cu care tratează informatorii Securității comuniste construiesc Madrigalului lui Marin Constantin un necesar și bine-meritat piedestal.” – Emil Pantelimon.",
      "Publicarea volumului „Corul Madrigal în arhivele Securității. Rezistența prin colind” se înscrie în programul aniversar MADRIGAL 60, care include o serie amplă de peste 40 de evenimente speciale, ce se desfășoară pe tot parcursul anului 2023. Programul marchează 60 de ani de activitate neîntreruptă, excelență în muzică și diplomație prin cultură pentru Corul Madrigal, devenit un simbol al constanței artistice naționale, dar și al relevanței culturale și de imagine a României în lume.",
      "*",
      "Corul Madrigal în arhivele Securității. Rezistența prin colind",
      "Autor: Monica Lup",
      "Editor: Emil Pantelimon",
      "Consilier editorial: Petre Străchinaru",
      "Redactor tehnic: Zita Horváth",
      "Proiect carte, layout: Attila Kopacz",
      "Tipar: TINTA printing studio, 2023",
      "*",
    ],
    image: "cm-rezistenta-prin-colind-2.jpg",
    price: 35,
  },
  {
    id: 19,
    title: "Corul Madrigal în arhivele Securității. Turneele în S.U.A",
    autor: "Monica Lup",
    editor: "Emil Pantelimon", 
    description: [
      "Lansat în Statele Unite, cu prilejul celui mai recent turneu al ansamblului - primul după 1988 - volumul „Corul Madrigal în arhivele Securității. Turneele în S.U.A: între libertatea muzicii și limitele sistemului comunist” este semnat de muzicologa Monica Lup, cu o prefaţă de Emil Pantelimon, managerul Corului Național de Cameră „Madrigal – Marin Constantin”.",
      "Documentate prin cercetări în arhivele Consiliului Național de Studiere a Arhivelor Securității și materialele epocii, cele 116 de pagini ale cărții reprezintă o cronică a modului în care regimul comunist din România a privit - și gestionat - cele cinci turnee pe care Corul Madrigal și dirijorul-fondator Marin Constantin le-au susținut în Statele Unite ale Americii, în perioada 1969 - 1988.",
      "„Cele cinci turnee ale Corului Madrigal în Statele Unite sunt spectaculoase prin dimensiunea lor, însumând concerte susținute în metropolele americane, cât și în localități de mai mici dimensiuni. Desfășurate în 1969, 1978 – în două reprize –, 1984 și în 1988, au reprezentat fără îndoială o performanță pentru o formație provenită dintr-o țară socialistă și i-au adus Madrigalului un prestigiu cu caracter de unicat, datorită numeroaselor apariții în presă. Muzicienii au fost întâmpinați peste tot cu bucurie, atât de românii stabiliți peste ocean, cât și de publicul american; la rândul lor, au trăit un vis, al unei vieți artistice libere în aparență, de neconceput în vremurile de tristă amintire, însă activitățile lor deveneau în subsidiar subiectul unei întregi literaturi constând în note informative, verificări și rapoarte existente astăzi în dosarele Consiliului Național de Studiere a Arhivelor Securității.” – Monica Lup",
      "„Ororile regimului comunist și ale Securității s-au răsfrânt și asupra Corului Madrigal. Cu această lucrare, Monica Lup începe o serie de cel puțin zec volume, în cadrul căreia aducem în lumina tiparului parte din miile de pagini de rapoarte și note de securitate scrise pe seama activității Corului Madrigal și a fondatorului său, Marin Constantin.” – Emil Pantelimon.",
      "Publicarea volumului „Corul Madrigal în arhivele Securității. Turneele în S.U.A” se înscrie în programul aniversar MADRIGAL 60, care include o serie amplă de peste 40 de evenimente speciale, ce se desfășoară pe tot parcursul anului 2023. Programul marchează 60 de ani de activitate neîntreruptă, excelență în muzică și diplomație prin cultură pentru Corul Madrigal, devenit un simbol al constanței artistice naționale, dar și al relevanței culturale și de imagine a României în lume.",
      "*",
      "Corul Madrigal în arhivele Securității. Turneele în S.U.A",
      "Autor: Monica Lup",
      "Editor: Emil Pantelimon",
      "Consilier editorial: Petre Străchinaru",
      "Redactor tehnic: Zita Horváth",
      "Proiect carte, layout: Attila Kopacz",
      "Tipar: TINTA printing studio, 2023",
      "*",
    ],
    image: "cm-turneele-in-sua-2.jpg",
    price: 35,
  },
  {
    id: 18,
    title: "Madrigal de Crăciun - for Christmas [DUBLU VINIL]",
    artist: "Corul Naţional de Cameră „Madrigal – Marin Constantin”",
    conductor: "Anna Ungureanu",
    description: [
      "Dublul vinil „ Madrigal de Crăciun - for Christmas” conține colindele celor două albume de colinde lansate de Corul Madrigal, în anul 2020, și premiate cu discul de aur.",
      "„Madrigal de Crăciun” prezintă 18 colinde autentice românești, din creația unora dintre cei mai talentați compozitori naționali.",
      "„Madrigal for Christmas” prezintă 14 colinde internaționale, atât clasice, cât și moderne, alese dintre cele mai frumoase și iubite compoziții dedicate Crăciunului.",
      "Înregistrările sunt realizate la standarde acustice de excepție și oferă atmosfera unică a extraordinarelor Concerte de Crăciun susținute de Corul Național de Cameră „Madrigal – Marin Constantin”, dirijat de Anna Ungureanu, la Ateneul Român și la Sala „Auditorium” a Muzeului Național de Artă în perioada 2017 – 2019.",
      "Categorie – Disc Vinil",
      "An lansare – 2023",
    ],
    image: "vinil-dublu-madrigal-de-craciun.jpg",
    price: 160,
    playlist: [
      "Disc vinil 1 - Madrigal de Crăciun",
      "PARTEA A",
      "1. Ion Costescu; Alexandru Podoleanu: „Bună dimineața la Moș Ajun” 1:41",
      "2. Costică Andrei: „Florile dalbe” 1:07",
      "3. Dumitru Georgescu Kiriac: „O, ce veste minunată” 2:53",
      "4. Sabin Drăgoi: „Colo-n susu`” 1:11",
      "5. Gheorghe Cucu: „Sus, boieri!” 1:42",
      "6. Anton Pann: „Trei Crai de la Răsărit (Solist: Silviu Năstase)” 2:59",
      "7. Achim Stoia: „Suita corală” 4:18",
      "8. Remus Georgescu: „Lerui, Doamne, Ler și Ziurel de ziuă” 3:45",
      "9. Dan Voiculescu: „Noi pornim la colindat” 2:04",
      "10. Alexandru Pașcanu: „După datini, colindăm” 2:48",
      "PARTEA B",
      "1. Alexandru Pașcanu: „Festum hibernum” 10:20",
      "2. Nicolae Ursu: „Vine Crăciunu` pe sară” 1:35",
      "3. I. D. Chirescu: „Steaua sus răsare” 1:51",
      "4. Nicolae Lungu: „Mărire-ntru cele-nalte” 1:14",
      "5. Mihail Bîrcă: „Noi umblăm și colindăm” 1:01",
      "6. Marius Hristescu: „Două colinde românești” 4:06",
      "7. Sabin Păutza: „Noi venim să colindăm” 1:29",
      "8. Alexandru Podoleanu – Ioan D. Chirescu: „Moș Crăciun cu plete dalbe și Bună dimineața la Moș Ajun” 2:22",
      "Disc vinil 2 - Madrigal for Christmas",
      "PARTEA A",
      "1. Michael John Trotta: „Veni, Veni Emmanuel” 3:05",
      "2. Jan Pieters Sweelinck: „Hodie Christus Natus Est” 3:00",
      "3. Șerban Nichifor: „Natalis Domini” 8:32",
      "4. Kodàly Zoltàn: „Veni, veni, Emanuel” 4:36",
      "5. Michael John Trotta: „Le bel Ange du Ciel” 2:06",
      "6. Mark Burrows: „Gaudete!” 2:02",
      "PARTEA B",
      "1. Arr. Marcello Noia: „God rest ye merry, gentlemen” 1:53",
      "2. John Francis Wade: „Adeste deles” 1:32",
      "3. Mykola Leontovych: „Shchedryk” 1:51",
      "4. James Pierpont; Arr. Dan Wolaver: „Jingle Bell Jazz” 2:05",
      "5. John Rutter: „All Bells in Paradise” 6:01",
      "6. John Rutter: „Deck the Hall” 1:32",
      "7. James Pierpont; Arr. Bernhard Hofmann: „Jingle Bells” 1:44",
      "8. Lloyd Larson: „A Christmas Blessing” 5:03",
    ],
  },
  {
    id: 17,
    title: "Spectacolul Extraordinar „Pe Drumul Crăciunului” [DVD BLU-RAY]",
    artist: "Corul Naţional de Cameră „Madrigal – Marin Constantin”",
    conductor: "Anna Ungureanu",
    description: [
      "Spectacolul „Pe drumul Crăciunului” pornește de la o poveste universală. Este povestea fiecăruia dintre noi, a fiecărei familii care ar putea să se despartă, independent de voința sa, atunci când se află în calea unor evenimente colective violente, ce pot dezrădăcina și pune la încercare valorile ce unesc o familie. Este o istorie în sunet și lumină a celor înstrăinați, care păstrează speranța regăsirii prin simbolul luminos al Crăciunului. Colindele și momentele muzicale interpretate de Corul Madrigal se întrepătrund cu dramatismul unei istorii arhetipale a familiilor destrămate din pricina valurilor istoriei, dar care, în final, își regăsesc seninul de care cu toții avem nevoie. Crăciunul devine acel timp magic, „căminul” esențial în care familia se regăsește, depășind durerea despărțirii și a traumei.",
      "Spectacolul Extraordinar „Pe drumul Crăciunului” prezentat în format video Blu-Ray este înregistrat integral la Opera Națională București.",
      "*",
      "Spectacolul Extraordinar PE DRUMUL CRĂCIUNULUI",
      "Corul Naţional de Cameră „Madrigal – Marin Constantin”",
      "Dirijor: Anna Ungureanu",
      "Regia şi scenariul: Emil Pantelimon",
      "Scenografia: Vladimir Turturica",
      "Selecţia textelor dramatice: Mădălin Guruianu",
      "La pian: Abel Corban",
      "Cu participarea corurilor de copii din Programul Național Cantus Mundi",
      "Invitaţi: Ofelia Popii – Mamă / Marius Turdeanu – Tată",
      "Copii: Amalia Constantinescu, Anastasia Ţântea, Alexandra Bârliba, Teodora Mateş",
      "Coregrafie copii: Andreea Soare",
      "Regie sunet: Gabriel Scîrlet",
      "Regie de pupitru: Arinna Florea / Paula Stoica",
      "Producţie video: Marius Portik",
      "Maestru lumini: Ştefan Dragu",
      "Montaj: Ana Lăzărescu / Alexandru Tamazlicaru",
      "*",
      "Categorie – DVD Blu-Ray",
      "An lansare – 2023"
    ],
    image: "dvd-pe-drumul-craciunului.jpg",
    price: 45,
  },
  {
    id: 16,
    title: "Pe Drumul Crăciunului LIVE din concert [VINIL]",
    artist: "Corul Naţional de Cameră „Madrigal – Marin Constantin”",
    conductor: "Anna Ungureanu",
    description: [
      "Spectacolul „Pe drumul Crăciunului” pornește de la o poveste universală. Este povestea fiecăruia dintre noi, a fiecărei familii care ar putea să se despartă, independent de voința sa, atunci când se află în calea unor evenimente colective violente, ce pot dezrădăcina și pune la încercare valorile ce unesc o familie. Este o istorie în sunet și lumină a celor înstrăinați, care păstrează speranța regăsirii prin simbolul luminos al Crăciunului. Colindele și momentele muzicale interpretate de Corul Madrigal se întrepătrund cu dramatismul unei istorii arhetipale a familiilor destrămate din pricina valurilor istoriei, dar care, în final, își regăsesc seninul de care cu toții avem nevoie. Crăciunul devine acel timp magic, „căminul” esențial în care familia se regăsește, depășind durerea despărțirii și a traumei.",
      "*",
      "PE DRUMUL CRĂCIUNULUI",
      "Corul Naţional de Cameră „Madrigal – Marin Constantin”",
      "Dirijor: Anna Ungureanu",
      "Regia şi scenariul: Emil Pantelimon",
      "Selecţia textelor dramatice: Mădălin Guruianu",
      "Regie sunet: Gabriel Scîrlet",
      "La pian: Abel Corban",
      "Cu participarea actorilor Ofelia Popii și Marius Turdeanu",
      "*",
      "Categorie – Disc Vinil",
      "An lansare – 2023"
    ],
    image: "vinil-pe-drumul-craciunului.jpg",
    price: 80,
    playlist: [
      "PARTEA A",
      "1. Alexandru Pașcanu: „Iarna pe uliță” 5:55",
      "2. Henry Martinet; arr. Ion Marin: „Petit Papa Nöel” 3:31",
      "3. Biblia: „Cântarea Cântărilor (fragment)” 3:14",
      "4. Gheorghe Cucu: „Coroană de trandafiri (Cetiniță, cetioară dragă)” 2:57",
      "5. Dan Buciu: „Remember Hiroshima” 8:07",
      "PARTEA B",
      "1. Khaled Hosseini: „Vânătorii de zmeie (fragment)” 1:31",
      "2. Ion Borgovan: „Moș Crăciun (fragment)” 02:53",
      "3. Prelucrare de Șerban Marcu: „Asta-i sara lui Crăciun” 4:19",
      "4. Anton Pann: „Rugăciunea Sfintei Tereza de Avila și Trei Crai de la Răsărit” 4:15",
      "5. Mykola Leontovych: „Shchedryk” 1:06",
      "6. Lucian Blaga: „Psalm” 1:56",
      "7. Visarion Șebalin: „Drum de iarnă (fragment)” 2:12",
      "8. Lucian Blaga: „Psalm” 0:33",
      "9. Mihail Bîrcă: „Noi umblăm și colindăm” 0:57",
      "10. Paulo Coelho: „La râul Piedra am șezut și-am plâns (fragment)” 1:25",
      "11. Dumitru Georgescu Kiriac: „O, ce veste minunată” 02:31",
      "12. Nicolae Lungu: „Mărire-ntru cele-nalte” 01:13",
    ],
  },
  {
    id: 15,
    title: "Marea Carte a Madrigalului",
    autor: "Mădălin Guruianu",
    editor: "Emil Pantelimon",
    concept: "Attila Kopacz",
    proofreading: "Alexandru Ujvarosi-Brezeanu",
    printing: "TINTA printing studio, 2023",   
    description: [
      "„Madrigal este monumentul natural al glasului uman în cântec.” - Nichita Stănescu",
      "Lansat la Salonul Internaţional de Carte Bookfest pe 28 mai 2023, volumul aniversar „Marea Carte a Madrigalului” este semnat de Mădălin Guruianu, cu o prefaţă de Emil Pantelimon.",
      "Tipărit în condițiii tehnice deosebite, volumul reprezintă un material biografic exhaustiv, care se adresează deopotrivă specialiștilor, dar și melomanilor și cititorilor intrigați și vrăjiţi de Madrigal, generație după generație.",
      "Cele peste 520 de pagini reunesc atât povestea unui artist fără pereche, Marin Constantin, cât și a operei sale miraculoase, Corul Madrigal, care, pe 11 aprilie 2023 a împlinit 60 de ani existență.",
      "Marin Constantin a fost un creator care, asemeni unui Demiurg, a reușit să ridice ex nihilo un ansamblu ce a cucerit realmente lumea întreagă – şi continuă să o farmece și după dispariția geniului care i-a dat naștere, şi care acum îi poartă numele: Corul Naţional de Cameră „Madrigal – Marin Constantin”.",
      "Emoția este numitorul comun, iar Madrigalul a fost, este și va fi generator de emoție. Paginile acestei Mari Cărți a Madrigalului generează emoție oricui le-ar răsfoi. Atât emoția și respectul celor 59 trecuți, cât și entuziasmul și energia lui 1 care urmează. Pentru că UNUL este Madrigalul!” - Emil Pantelimon, managerul  Corului Naţional de Cameră „Madrigal – Marin Constantin”.",
      "Publicarea volumului „Marea Carte a Madrigalului” se înscrie în programul aniversar MADRIGAL 60, care include o serie amplă de peste 40 de evenimente speciale, ce se desfășoară pe tot parcursul anului 2023. Programul marchează 60 de ani de activitate neîntreruptă, excelență în muzică ți diplomație prin cultură pentru Corul Madrigal, devenit un simbol al constanței artistice naționale, dar și al relevanței culturale și de imagine a României în lume.",
    ],
    image: "marea-carte-a-madrigalului-2.jpg",
    price: 235,
  },
  {
    id: 14,
    title: "Hora staccato",
    artist: "Corul Național de Cameră „Madrigal – Marin Constantin”",
    conductor: "Anna Ungureanu",
    description: [
      "Plin de culoare și dinamism, albumul „Hora staccato” îmbină sonoritatea inconfundabilă a Corului Național de Cameră „Madrigal – Marin Constantin” cu muzicalitatea specială și emoția unică a compozițiilor inspirate din filonul autentic românesc și este dedicat tuturor românilor.",
      "Albumul „Hora staccato” prezintă un repertoriu special, ales de Anna Ungureanu, dirijorul principal al corului, ce reunește o colecție de lucrări care pun în valoare creații naționale nepieritoare, aduse la lumină de mari compozitori români, de la Dumitru Georgescu Kiriac, Mihail Jora și Francisc Hubic, până la Marin Constantin, Cornelia Tăutu și Dan Mihai Goia.",
    ],
    image: "cd-hora-staccato.jpg",
    price: 33,
    playlist: [
      "1. Arr. Dan Mihai Goia: „Cântec și joc (Mociriță)” 3:42",
      "2. Gavriil Musicescu: „Trompetele răsună” 1:32",
      "3. Tudor Jarda: „Mă luai, luai”  2:02",
      "4. Constantin Rîpă: Codex Caioni: „Dans valah”, „Cântecul Voievodesei Lupu” și „Dans al cincilea în șase” 4:35",
      "5. Mihail Jora: „Mă mieram” 1:42",
      "6. Dumitru Georgescu Kiriac: „Am umblat pădurile” 1:22",
      "7. Iacob Mureșianu: „Neică, neiculiță” 1:08",
      "8. Vadim P. Șumski: „Veselie” 2:07",
      "9. Marin Constantin: „Hora la români”  2:03",
      "10. Francisc Hubic: „Suită de cântece vechi din Bihor” 5:31",
      "11. Gheorghe Danga: „Sârba pe loc” 1:48",
      "12. Cornelia Tăutu: „Jocuri” (divertisment folcloric) 5:00",
      "13. Arr. Nicolae Gîscă: „Hora staccato” 1:56",
      "14. Alexandru Pașcanu: „Sârba pe scaun” 1:58",
    ],
  },
  {
    id: 13,
    title: "Săptămâna Patimilor",
    artist: "Corul Național de Cameră „Madrigal – Marin Constantin”",
    conductor: "Cezar Verlan",
    description: [
      "Corul Național de Cameră „Madrigal – Marin Constantin”, împreună cu Roton Music, celebrează și anul acesta Sărbătorile Pascale atât de importante pentru credincioșii de rit ortodox, oferindu-le o experiență muzicală înălțătoare prin noul Album „Săptămâna Patimilor”.",
      "Albumul prezintă un repertoriu ales cu grijă de către dirijorul Cezar-Mihail Verlan și include o serie de compoziții menite să redea emoția specifică Sărbătorilor Pascale și, în special, simbolismul și dramatismul săptămânii premergătoare Învierii.",
      "Programul artistic are menirea de a reconstitui ultimele momente din viața Mântuitorului Iisus Hristos, începând cu Duminica Floriilor, trecând prin fiecare zi din Săptămâna Patimilor, mergând apoi către moartea și punerea Lui în mormânt și culminand cu Învierea Sa.",
      "Un moment profund și emoționant în același timp este acela în care in Vinerea Mare, în urma morții Mântuitorului, toată suflarea cântă Prohodul.",
      "In acest demers artistic, Corul Madrigal dirijat de Cezar-Mihail Verlan a avut alături și o parte din copiii din corurile înscrise în Programul Național Cantus Mundi, creionând o imagine extrem de sensibilă a momentului.",
    ],
    image: "cd-saptamana-patimilor.jpg",
    price: 33,
    playlist: [
      "1. Ioan D. Chirescu: Axion la Duminica Floriilor 3:09",
      "2. Gheorghe Cucu: Doamne, Iisuse Hristoase 2:51",
      "3. Nicolae Lungu: Doamne, auzi glasul meu (Solistă: Teodora Jaworski)  5:15",
      "4. Ioan D. Chirescu: Cămara Ta, Mântuitorule 3:17",
      "5. Gheorghe Danga; arr. Petru Simionescu: Fie, Doamne, mila Ta... 3:36",
      "6. Florian Costea: Lumină lină 3:32",
      "7. Ioan D. Chirescu: Fericirile 4:00",
      "8. Gheorghe Popescu: Privegheați și vă rugați – Brănești; arr. Dan Mihai Goia (Solistă: Anna Mirescu) 3:58",
      "9. Gheorghe Mandicevski; arr. Petru Simionescu: Oratoriu  3:12",
      "10. Arr. Nicolae Lungu: Prohodul Domnului, fragmente (Solist: Doru Feraru, Interpretează Corul Madrigal și corurile din Programul Național Cantus Mundi)  11:07",
      "11. Arr. Nicolae Lungu: Luminânda Învierii Domnului 1:33",
      "12. Grigore Cudalbu: Festum primaverae, fragment (Solistă: Ramona Nicolau; Percuție: Emanuel Pecingină; Intervenții recitate: Ana- Maria Velcea, Radu Isăcescu, Bogdan Andronache, Denis Maxim, Dragoș Petrică)  6:37",
      "13. Ioan D. Chirescu: Ziua Învierii 3:05",
      "14. Mircea Valeriu Diaconescu: Aliluiia, Aleluia - Slavă Ție, Doamne  2:16",
      "15. Florilegiu bizantin ortodox non-canonic (fragmente): „Hristos anesti” - Marin Constantin, Gavriil Musicescu - Interpretează Corul Madrigal și corurile din Programul Național Cantus Mundi, dirijor: Anna Ungureanu  2:23",
    ],
  },
  {
    id: 12,
    title: "Ave Maria",
    artist: "Corul Național de Cameră „Madrigal – Marin Constantin”",
    conductor: "Anna Ungureanu",
    description: [
      "Cu ocazia Sărbătorilor Pascale celebrate de credincioșii de rit catolic și protestant, Corul Național de Cameră „Madrigal – Marin Constantin” și Roton Music lansează un album de o sensibilitate aparte, dedicat Fecioarei Maria. Prin albumul „Ave Maria”, Corul Madrigal, dirijat de Anna Ungureanu, aduce în atenția publicului lucrări din creația românească și internațională, de facturi și stiluri diferite, de inspirație sacră, de la motete ale Renașterii până la partituri complexe din istoria muzicii universale.",
      "Avându-i ca invitați pe Marius Manole, Ansamblul de percuție Young Beats, coodronat de Zoli TOTH, precum și pianistul Abel Corban, albumul „Ave Maria” este inspirat din Concertul extraordinar cu același nume, din Stagiunea estivală Madrigal 2020.",
      "Desfășurat cu „casa închisă” la Amfiteatrul „Mihai Eminescu” din București, concertul „Ave Maria”, dirijat de Anna Ungureanu, s-a bucurat de un imens succes în rândul spectatorilor, astfel încât, pe 2 octombrie 2020 a fost organizată o nouă reprezentație a acestuia pentru public.",
      "Categorie – CD",
      "Label – Roton Music",
      "An lansare – 2021",
    ],
    image: "cd-madrigal-ave-maria.jpg",
    price: 33,
    playlist: [
      "1. Hans Leo Hassler: Cantate Domino 1:23",
      "2. Serghei Rahmaninov: Bogoroditse Devo 3:00",
      "3. Francisc Hubic: Cuvine-se cu adevărat (Solist: Denis Maxim) 4:10",
      "4. Filotei Monahul: Pripeala (Solist: Silviu Năstase) 5:30",
      "5. Tomas Luis de Victoria: Ave Maria 3:28",
      "6. Ola Gjeilo: Ubi caritas 3:11",
      "7. Gabriel Fauré: In paradisum (La orgă: Abel Corban) 3:43",
      "8. Knut Nystedt: Laudate 1:20",
      "9. Giulio Caccini: Ave Maria (Percuție: Ansamblul de percuție Young Beats coordonat de Zoli Toth) 2:41",
      "10. Anton Bruckner: Os justi 5:13",
      "11. Tudor Arghezi: Psalmi (Interpretează: Marius Manole;) 1:41",
      "12. Charles Gounod: Ave Maria (Solistă: Anna Mirescu. La orgă: Abel Corban) 3:17",
      "13. Vytautas Miškinis: Pater noster (Soliste: Roxana Ilie, Alexandra Spireanu, Anna Mirescu) 5:45",
      "14. John Leavitt: Festival Sanctus (La pian: Abel Corban) 2:43",
      "15. Vytautas Miškinis: Cantate Domino 3:05",
      "16. Jacob de Haan: Benedictus (Percuție: Ansamblul de percuție Young Beats coordonat de Zoli Toth. Recitator: Marius Manole) 4:40",
    ],
  },
  // {
  //   id: 11,
  //   title: "Madrigal de Crăciun - For Christmas",
  //   artist: "Corul Național de Cameră „Madrigal – Marin Constantin”",
  //   conductor: "Anna Ungureanu",
  //   description: [
  //     "Dublul albumul „MADRIGAL DE CRĂCIUN – FOR CHRISTMAS” conține cele două CD-uri de colinde lansate în anul 2020 de către Corul Madrigal.",
  //     "„MADRIGAL DE CRĂCIUN” prezintă 18 colinde autentice românești, din creația unora dintre cei mai talentați compozitori naționali.",
  //     "„MADRIGAL FOR CHRISTMAS” prezintă 14 colinde internaționale, atât clasice, cât și moderne, alese dintre cele mai frumoase și iubite compoziții dedicate Cărciunului.",
  //     "Înregistrările sunt realizate la standarde acustice de excepție și oferă atmosfera unică a extraordinarelor Concerte de Crăciun susținute de Corul Național de Cameră „Madrigal – Marin Constantin”, dirijat de Anna Ungureanu, la Ateneul Român și la Sala „Auditorium” a Muzeului Național de Artă în perioada 2017 – 2019.",
  //     "Categorie – CD",
  //     "Label – Roton Music",
  //     "An lansare – 2020",
  //   ],
  //   image: "cd-dublu-craciun.jpg",
  //   price: 45,
  //   playlist: [
  //     "CD 1:",
  //     "1. Ion Costescu – Alexandru Podoleanu: Bună dimineața la Moș Ajun - Bună dimineața la Moș Ajun 1:41",
  //     "2. Costică Andrei: Florile dalbe 1:07",
  //     "3. Dumitru Georgescu Kiriac: O, ce veste minunată 2:53",
  //     "4. Sabin Drăgoi: Colo-n susu` 1:11",
  //     "5. Gh. Cucu: Sus, boieri! 1:42",
  //     "6. Anton Pann: Trei Crai de la Răsărit (Solist: Silviu Năstase) 2:59",
  //     "7. Achim Stoia: Suita corală 4:18",
  //     "8. Alexandru Pașcanu: Festum hibernum 10:20",
  //     "9. Dan Voiculescu: Noi pornim la colindat 2:04",
  //     "10. Remus Georgescu: Lerui, Doamne, Ler și Ziurel de ziuă 3:45",
  //     "11. Alexandru Pașcanu: După datini, colindăm 2:48",
  //     "12. Nicolae Ursu: Vine Crăciunu` pe sară 1:35",
  //     "13. I. D. Chirescu: Steaua sus răsare 1:51",
  //     "14. Nicolae Lungu: Mărire-ntru cele-nalte 1:14",
  //     "15. Mihail Bîrcă: Noi umblăm și colindăm 1:01",
  //     "16. Marius Hristescu: Două colinde românești 4:06",
  //     "17. Sabin Păutza: Noi venim să colindăm 1:29",
  //     "18. Alexandru Podoleanu – Ioan D. Chirescu: Moș Crăciun cu plete dalbe și Bună dimineața la Moș Ajun 2:22",
  //     "CD 2:",
  //     "1. Michael John Trotta: Veni, Veni Emmanuel   1:41",
  //     "2. Jan Pieters Sweelinck: Hodie Christus Natus Est   3:00",
  //     "3. Șerban Nichifor: Natalis Domini   8:32",
  //     "4. Kodàly Zoltàn: Veni, veni, Emanuel   4:40",
  //     "5. Michael John Trotta: Le bel Ange du Ciel    1:41",
  //     "6. Mark Burrows: Gaudete!   2:05",
  //     "7. Arr. Marcello Noia: God rest ye merry, gentlemen   1:54",
  //     "8. John Francis Wade: Adeste fideles   1:34",
  //     "9. Mykola Leontovych: Shchedryk   1:14",
  //     "10. James Pierpont; arr. Dan Wolaver: Jingle Bell Jazz   2:07",
  //     "11. John Rutter: All Bells in Paradise   6:03",
  //     "12. John Rutter: Deck the Hall   1:32",
  //     "13. James Pierpont; arr. Bernhard Hofmann: Jingle Bells   1:44",
  //     "14. Lloyd Larson: A Christmas Blessing   5:06",
  //   ],
  // },
  // {
  //   id: 9,
  //   title: "„Madrigal de Crăciun”",
  //   artist: "Corul Național de Cameră „Madrigal – Marin Constantin”",
  //   conductor: "Anna Ungureanu",
  //   description: [
  //     "Albumul „Madrigal de Crăciun” prezintă o selecție de 18 colinde autentice românești, din\n" +
  //       "creația unora dintre cei mai talentați compozitori naționali. Înregistrările sunt realizate la\n" +
  //       "standarde acustice de excepție și oferă atmosfera unică a extraordinarelor Concerte de\n" +
  //       "Crăciun susținute de Corul Național de Cameră „Madrigal – Marin Constantin”, dirijat de\n" +
  //       "Anna Ungureanu, la Ateneul Român și la Sala „Auditorium” a Muzeului Național de Artă\n" +
  //       "în perioada 2017 – 2019.",
  //     "Categorie – CD",
  //     "Label – Roton Music",
  //     "An lansare – 2020",
  //   ],
  //   playlist: [
  //     "1. Ion Costescu – Alexandru Podoleanu: Bună dimineața la Moș Ajun - Bună dimineața la Moș Ajun 1:41",
  //     "2. Costică Andrei: Florile dalbe 1:07",
  //     "3. Dumitru Georgescu Kiriac: O, ce veste minunată 2:53",
  //     "4. Sabin Drăgoi: Colo-n susu` 1:11",
  //     "5. Gh. Cucu: Sus, boieri! 1:42",
  //     "6. Anton Pann: Trei Crai de la Răsărit (Solist: Silviu Năstase) 2:59",
  //     "7. Achim Stoia: Suita corală 4:18",
  //     "8. Alexandru Pașcanu: Festum hibernum 10:20",
  //     "9. Dan Voiculescu: Noi pornim la colindat 2:04",
  //     "10. Remus Georgescu: Lerui, Doamne, Ler și Ziurel de ziuă 3:45",
  //     "11. Alexandru Pașcanu: După datini, colindăm 2:48",
  //     "12. Nicolae Ursu: Vine Crăciunu` pe sară 1:35",
  //     "13. I. D. Chirescu: Steaua sus răsare 1:51",
  //     "14. Nicolae Lungu: Mărire-ntru cele-nalte 1:14",
  //     "15. Mihail Bîrcă: Noi umblăm și colindăm 1:01",
  //     "16. Marius Hristescu: Două colinde românești 4:06",
  //     "17. Sabin Păutza: Noi venim să colindăm 1:29",
  //     "18. Alexandru Podoleanu – Ioan D. Chirescu: Moș Crăciun cu plete dalbe și Bună dimineața la Moș Ajun 2:22",
  //   ],
  //   image: "cd-madrigal-de-craciun.jpg",
  //   price: 34,
  // },
  {
    id: 10,
    title: "„Madrigal for Christmas”",
    artist: "The National Chamber Choir „Madrigal – Marin Constantin”",
    conductor: "Anna Ungureanu",
    description: [
      '"Madrigal for Christmas" presents 14 international carols, the most beautiful and beloved\n' +
        "compositions dedicated to Christmas, both classic and from the modern register. The\n" +
        "recordings are made to exceptional acoustic standards and offer the unique atmosphere of\n" +
        "the Extraordinary Christmas Concerts performed by the National Chamber Choir\n" +
        '"Madrigal – Marin Constantin", conducted by Anna Ungureanu, at the Romanian\n' +
        'Athenaeum and at the "Auditorium" Hall of the National Museum of Art in 2017, 2018\n' +
        "and 2019.",
      "Category – CD",
      "Label – Roton Music",
      "Release – 2020",
    ],
    playlist: [
      "1. Michael John Trotta: Veni, Veni Emmanuel   1:41",
      "2. Jan Pieters Sweelinck: Hodie Christus Natus Est   3:00",
      "3. Șerban Nichifor: Natalis Domini   8:32",
      "4. Kodàly Zoltàn: Veni, veni, Emanuel   4:40",
      "5. Michael John Trotta: Le bel Ange du Ciel    1:41",
      "6. Mark Burrows: Gaudete!   2:05",
      "7. Arr. Marcello Noia: God rest ye merry, gentlemen   1:54",
      "8. John Francis Wade: Adeste fideles   1:34",
      "9. Mykola Leontovych: Shchedryk   1:14",
      "10. James Pierpont; arr. Dan Wolaver: Jingle Bell Jazz   2:07",
      "11. John Rutter: All Bells in Paradise   6:03",
      "12. John Rutter: Deck the Hall   1:32",
      "13. James Pierpont; arr. Bernhard Hofmann: Jingle Bells   1:44",
      "14. Lloyd Larson: A Christmas Blessing   5:06",
    ],
    image: "cd-madrigal-for-christmas.jpg",
    price: 34,
  },
  {
    id: 1,
    title: "Bijuterii Corale Românești",
    artist: "Corul Național de Cameră Madrigal",
    conductor: "Marin Constantin",
    description: [
      "Albumul „Bijuterii Corale Românești” conține o selecție a unora dintre cele mai reprezentative lucrări corale compuse special de creatorii români pentru Corul Național de Cameră „Madrigal”. ",
      "Categorie – CD",
      "Label – Electrecord",
      "Maestru de sunet – Cornelia Andreescu",
      "An lansare – 2008",
      "Cu sprijinul Ministerului Educației, Cercetării și Tineretului",
    ],
    playlist: [
      "1. I Vidu: Răsunetul Ardealului 6:05",
      "2. P. Constantinescu: Doina oltenească 5:24",
      "3. G. Dima: Ziua ninge, noaptea ninge 4:34",
      "4. T. Popovici: Trei păstori 3:02",
      "5. T. Brediceanu: S-a dus cucul 1:20",
      "6. T. Teodorescu: Doina 5:33",
      "7. I. Vidu: Preste deal 5:56",
      "8. D. G. Kiriac: Morarul 2:50",
      "9. D. G. Kiriac: Auzi, Doamne, glasul meu 4:30",
      "10. G. Mandicevski: Și era la ora șasea 4:50",
      "11. I. Chirescu: Fericirile 4:34",
      "12. G. Cucu: Miluiește-mă, Dumnezeule! 4:42",
      "13. P. Constantinescu: Condacul nașterii din „Oratoriul Bizantin de Crăciun” 1:46",
      "14. T. Flondor: Somnoroase păsărele 3:47",
      "15. Ștefan Popescu: Fluturele 2:39",
      "16. S: Drăgoi: Trandafir de pe răzoare 6:33",
      "17. N. Ursu: Vine Crăciunul pe sară 2:22",
      "18. I. Chirescu: Mama 3:07",
      "19. N. Lungu: Mărire-ntru cele-nalte 1:22",
      "20. D. G. Kiriac: Amumblat pădurile 1:26",
    ],
    image: "romanian-choral-jewels.jpeg",
    price: 29,
  },
  {
    id: 2,
    title:
      "Volum de artă: Album fotografii „Via Dolorosa” & CD „Florilegiul Bizantin” (fragment) de Marin Constantin",
    artist:
      "Corul Național de Cameră „Madrigal – Marin Constantin”, Corurile de copii din Programul Național Cantus Mundi",
    conductor: "Anna Ungureanu",
    description: [
      "Volumul conține Albumul de fotografii create de Gabriel Crișan și CD-ul cu înregistrarea lucrării „Florilegiul Bizantin” (fragment) structurat de Marin Constantin. Fotografiile selectate pentru album fac parte Expoziția de fotografie „Drumul Crucii”, prezentată cu ocazia evenimentelor de Paște organizate de Corul Madrigal în aprilie 2019. Lucrările realizate de fotograful Gabriel Crișan au fost expuse în spațiul exterior al Ateneului Român și au adus pentru două zile imagini simbolice din Ierusalim: Grădina Ghetsimani, Via Dolorosa, Zidul Plângerii, Biserica Tuturor Națiunilor sau Biserica Agoniei, precum și frânturi din viața cotidiană a orașului celor mari trei religii ale lumii.",
      "„Florilegiu Bizantin” ortodox non-canonic reprezintă o suită de lucrări de inspirație religioasă, de o noblețe spirituală aparte. Antologia structurată de către maestrul Marin Constantin, cu tonalități originale de la Muntele Athos și din mănăstirile românești, conține compozițiile muzicale ale lui Ioan Hrisafi, Gavriil Musicescu, Paul Constantinescu, Gheorghe Cucu, Evghenie Humulescu și Ioan D. Chirescu. „Florilegiu Bizantin” a fost inclus pentru prima oară în repertoriul Corului Madrigal în anul septembrie 1985, cu ocazia turneului de la Bologna.  Pentru această versiune a lucrării, înregistrată în luna martie 2019, Corul Național de Cameră „Madrigal – Marin Constantin” a cântat împreună cu copiii din corurile Programului Național Cantus Mundi, cea mai mare mișcare națională de intergrare socială a copiilor prin muzică.",
      "Categorie –Album de artă fotografică și CD",
      "O producție a Corului Național de Cameră „Madrigal – Marin Constantin”",
      "An lansare - 2019",
    ],
    playlist: [
      "„Florilegiul Bizantin” (fragment) structurat de Marin Constantin 6:20",
    ],
    image: "expozitie-de-arta-fotografica.jpg",
    price: 50,
  },
  {
    id: 3,
    title: "„Noapte de decembrie” – Concert de colinde și poezii",
    artist: "Corul Național de Cameră „Madrigal”",
    conductor: "Marin Constantin",
    playlist: [
      "1. Prezentare Ștefan Iordache 8:05",
      "2. T. Popovici: Astăzi s-a născut Hristos 1:05",
      "3. A. Podoleanu - I. D. Chirescu: Moș Crăciun cu plete dalbe și Bună dimineața la Moș Ajun 2:33",
      "4. D.G. Kiriac : O, ce veste minunată și Plecarea magilor 3:56",
      "5. V. Popovici: Închinarea magilor 1:37",
      "6. D.G.Kiriac: Nouă azi ne-a rasarit 3:21",
      "7. M. Bârcă: Noi umblăm și colindăm 1:13",
      "8. S. Esenin: Vanturi, vânturi pline de zăpadă 1:45",
      "9. T. Arghezi: Iarna blajină 2:12",
      "10. G. Topârceanu: Noapte de iarnă 3:51",
      "11. G. Fr. Handel: Joy to the world 1:40",
      "12. A. Ramirez: Colind argentinian (solo: Florian Costea – tenor) 4:06",
      "13. H. Martinet (arj. Ion Marin):Petit Papa Noel 4:18",
      "14. A. Adam: Noel (solo: Veronica Stoica – mezzosoprană) 4:15",
      "15. Fr. Gruber: Stille Nacht 4:01",
      "16. J. Pierpont: Jingle bells 2:40",
      "17. I. Minulescu: De vorbă cu iarna 1:55",
      "18. M. Eminescu: Colinde, colinde 1:00",
      "19. V. Teodorian: Legănelul lui Iisus 2:04",
      "20. I. Borgovan: Moșs Crăciun 4:24",
      "21. E. Monția: Sus la poarta Raiului și Colindița 2:44",
      "22. Gh. Cucu: Mare-i seara deastă seară 4:06",
      "23. Fr. Hubic: Floricica 2:54",
      "24. N. Lungu: Mărire-ntru cele-nalte 1:27",
      "25. N. Ursu: Vine Crăciunul pe sară 2:22",
    ],
    description: [
      "Corul Național de Cameră „Madrigal” dirijat de Marin Constantin (1-7,11-16,19-25), recită actorul Ștefan Iordache (8-10,17,18). Înregistrare live de la Sala mare a Palatului din București, 9 decembrie 2005.",
      "„Noapte de decembrie”  este un concert inedit și sensibil, în care vechile cântece bizantine și românești, colindele de Craciun și piesele de inspirație folclorică interpretate de Corul Madrigal, condus de maestrul Marin Constantin, sunt acompaniate de recitalul de poezie al actorului Ștefan Iordache.",
      "Recită actorul Ștefan Iordache",
      "Categorie – CD",
      "Label - Electrecord",
      "An lansare - 2008",
    ],
    image: "noapte-de-decembrie-madrigal.jpg",
    price: 29,
  },
  // {
  //   id: 4,
  //   title: "EDIȚIE DE COLECȚIE  - VOLUMUL I",
  //   artist: "Corul Național de Cameră Madrigal",
  //   conductor: "Marin Constantin",
  //   playlist: [
  //     "CD 1",
  //     "1. Prezentare Ștefan Iordache 8:05",
  //     "2. T. Popovici: Astăzi s-a născut Hristos 1:05",
  //     "3. A. Podoleanu - I. D. Chirescu: Moș Crăciun cu plete dalbe și Bună dimineața la Moș Ajun 2:33",
  //     "4. D.G. Kiriac : O, ce veste minunată și Plecarea magilor 3:56",
  //     "5. V. Popovici: Închinarea magilor 1:37",
  //     "6. D.G.Kiriac: Nouă azi ne-a rasarit 3:21",
  //     "7. M. Bârcă: Noi umblăm și colindăm 1:13",
  //     "8. S. Esenin: Vanturi, vânturi pline de zăpadă 1:45",
  //     "9. T. Arghezi: Iarna blajină 2:12",
  //     "10. G. Topârceanu: Noapte de iarnă 3:51",
  //     "11. G. Fr. Handel: Joy to the world 1:40",
  //     "12. A. Ramirez: Colind argentinian (solo: Florian Costea – tenor) 4:06",
  //     "13. H. Martinet (arj. Ion Marin):Petit Papa Noel 4:18",
  //     "14. A. Adam: Noel (solo: Veronica Stoica – mezzosoprană) 4:15",
  //     "15. Fr. Gruber: Stille Nacht 4:01",
  //     "16. J. Pierpont: Jingle bells 2:40",
  //     "17. I. Minulescu: De vorbă cu iarna 1:55",
  //     "18. M. Eminescu: Colinde, colinde 1:00",
  //     "19. V. Teodorian: Legănelul lui Iisus 2:04",
  //     "20. I. Borgovan: Moșs Crăciun 4:24",
  //     "21. E. Monția: Sus la poarta Raiului și Colindița 2:44",
  //     "22. Gh. Cucu: Mare-i seara deastă seară 4:06",
  //     "23. Fr. Hubic: Floricica 2:54",
  //     "24. N. Lungu: Mărire-ntru cele-nalte 1:27",
  //     "25. N. Ursu: Vine Crăciunul pe sară 2:22",
  //     "CD 2",
  //     "1. Paul Constantinescu - Pe versuri de Mihai Eminescu - Freamăt de codru 7:38",
  //     "2. Paul Constantinescu - Pe versuri de Mihai Eminescu - La mijloc de codru des 2:42",
  //     "3. Paul Constantinescu - Pe versuri de Mihai Eminescu - Peste vârfuri 6:28",
  //     "4. Paul Constantinescu - Pe versuri de Mihai Eminescu - Stelele-n cer 2:24",
  //     "5. Pascal Bentoiu - Preludiu Coral la Opera „Hamlet” 6:34",
  //     "6. Liana Alexandra - Soarele și Luna (Solo: Vladimir Popescu Deveselu) 11:09",
  //     "7. Laurențiu Profeta - Popas la Mănăstirea Putna 6:11",
  //     "8. Șerban Nichifor - Valurile, vânturile... pe versuri de Mihai Eminescu (înregistrare din concert) 8:22",
  //     "9. Liviu Glodeanu – Sabarcalina Suită pentru „Madrigal” și jucării muzicale 4:38",
  //     "10. Nicolae Bretan - „Rugă” din opera „Horia” (înregistrare din concert) 2:36",
  //     "11. Mihai Moldovan - Corijențe la canto academic – parodii (înregistrare din concert la Festivalul „George Enescu”, 1988) 7:25",
  //   ],
  //   description: [
  //     "Dublul album „Corul Național de Cameră Madrigal - EDIȚIE DE COLECȚIE”, Volumul I conține două compact discuri cu o selecție a unora dintre cele mai frumoase lucrări corale de arhivă interpretate de faimosul anasamblu coral, dirijat de maestrul Marin Constantin.",
  //     "CD 1 - „Noapte de decembrie” – Concert de colinde și poezii",
  //     "Corul Național de Cameră „Madrigal” dirijat de Marin Constantin (1-7,11-16,19-25), recită actorul Ștefan Iordache (8-10,17,18). Înregistrare live de la Sala mare a Palatului din București, 9 decembrie 2005.",
  //     "CD 2  - Muzică Contemporană",
  //     "Categorie – Dublu CD",
  //   ],
  //   image: "collection-edition-i.jpg",
  //   price: 50,
  // },
  // {
  //   id: 5,
  //   title: "EDIȚIE DE COLECȚIE  - VOLUMUL II",
  //   artist: "Corul Național de Cameră Madrigal ",
  //   conductor: "Marin Constantin",
  //   playlist: [
  //     "CD 1",
  //     "1. T. Popovici: Astăzi s-a născut Hristos 00:53",
  //     "2. D. G. Kiriac: Nouă azi ne-a rasarit 3:21",
  //     "3. I. D. Chirescu: Moș Crăciun cu plete dalbe și I. Costescu: Bună dimineața la Moș Ajun 3:18",
  //     "4. T. Popovici: Trei păstori 2:59",
  //     "5. G. Cucu: Cetiniță, cetioara 2:42",
  //     "6. V. Teodorian: Legănelul lui Iisus 2:04",
  //     "7. I. Borgovan / O. Goga: Moș Crăciun 4:00",
  //     "8. N. Ursu: Vine Crăciunul pe sară 2:22",
  //     "9. P. Constantinescu: „Podobia'' din Oratoriul de Craciun 2:37",
  //     "10. A. Podoleanu / I. D. Chirescu: Bună dimineața la Moș Ajun 00:45",
  //     "11. T. Brediceanu: Iată vin colindătorii 00:50",
  //     "12. D.G. Kiriac : O, ce veste minunată și Plecarea magilor 3:56",
  //     "13. A. Pann - culegere folclor: Trei Crai de la Rasarit 3:00",
  //     "Soloist: Ștefan Pruteanu",
  //     "14. S. Dragoi: Colo-n susu 1:05",
  //     "15. G. Cucu: Domnuleț și Domn din cer 3:35",
  //     "16. E. Monția: Sus la poarta Raiului și Colindița 2:44",
  //     "17. I. Chirescu: Steaua sus răsare 1:55",
  //     "18. N. Lungu: La Vitleem colo-n jos 2:40",
  //     "19. A. Pann - culegere folclor: La nunta din Cana Galileei 1:58",
  //     "20. I. Cocișiu: Colinda de păcurar 1:05",
  //     "21. Fr. Hubic: Floricica 2:54",
  //     "22. V. Popovici: Velerim și Veler Doamne 1:10",
  //     "23. V. Popovici: Ziurel de ziuă 1:40",
  //     "24. G. Cucu: Colindă de Florii 1:40",
  //     "25. M. Bârcă: Noi umblăm și colindăm 1:13",
  //     "26. Paul Constantinescu: Condacul nașterii din Oratoriul de Crăciun 1:46",
  //     "27. T. Popovici: Praznic luminos 2:13",
  //     "28. I. D. Chirescu: Colo-n umbra pomilor 3:55",
  //     "29. V. Popovici: Închinarea magilor 1:37",
  //     "30. N. Ursu: Se preumblă Maica sfântă 2:59",
  //     "31. Gh. Cucu: Domn, Domn, să-nălțăm 1:18",
  //     "32. N. Lungu: Mărire-ntru cele-nalte 1:27",
  //     "CD 2",
  //     "1. I Vidu: Răsunetul Ardealului (Solist: Lucian Bonifaciu) 6:05",
  //     "2. P. Constantinescu: Doina oltenească (Solist: Eremia Stere) 5:24",
  //     "3. G. Dima: Ziua ninge, noaptea ninge 4:34",
  //     "4. T. Popovici: Trei păstori 3:02",
  //     "5. T. Brediceanu: S-a dus cucul 1:20",
  //     "6. T. Teodorescu: Doina 5:33",
  //     "7. I. Vidu: Preste deal (Solist: Lucian Bonifaciu) 5:56",
  //     "8. D. G. Kiriac: Morarul 2:50",
  //     "9. D. G. Kiriac: Auzi, Doamne, glasul meu 4:30",
  //     "10. G. Mandicevski: Și era la ora șasea 4:50",
  //     "11. I. Chirescu: Fericirile 4:34",
  //     "12. G. Cucu: Miluiește-mă, Dumnezeule! 4:42",
  //     "13. P. Constantinescu: Condacul nașterii din „Oratoriul Bizantin de Crăciun” 1:46",
  //     "14. T. Flondor: Somnoroase păsărele (Solist: Valentin Teodorian) 3:47",
  //     "15. Ștefan Popescu: Fluturele 2:39",
  //     "16. S: Drăgoi: Trandafir de pe răzoare 6:33",
  //     "17. N. Ursu: Vine Crăciunul pe sară 2:22",
  //     "18. I. Chirescu: Mama (Solist: Nicolae Herlea) 3:07",
  //     "19. N. Lungu: Mărire-ntru cele-nalte 1:22",
  //     "20. D. G. Kiriac: Amumblat pădurile 1:26",
  //   ],
  //   description: [
  //     "Dublul album „Corul Național de Cameră Madrigal - EDIȚIE DE COLECȚIE”  - Volumul II conține două compact discuri cu o selecție a unora dintre cele mai frumoase lucrări corale de arhivă interpretate de faimosul anasamblu coral, dirijat de maestrul Marin Constantin.",
  //     "CD 1 - „Romanian Christmas Carols”",
  //     "CD 2 - „Bijuterii Corale Românești”",
  //     "Înregistrările au fost realizate în Sala de Marmură a Casei Scânteii în anii 1966, 1976, 1986, 1989 și 1990. ",
  //     "Categorie – Dublu CD",
  //   ],
  //   image: "collection-edition-ii.jpg",
  //   price: 50,
  // },
  {
    id: 6,
    title: "„Concert Extraordinar de Crăciun” la Palatul Cotroceni",
    artist:
      "Corul Național de Cameră „Madrigal – Marin Constantin”, Corurile de copii Cantus Mundi",
    conductor: "Anna Ungureanu",
    playlist: [],
    description: [
      "LIVE - „Concertul Extraordinar de Crăciun”",
      "Înregistrare efectuată la Palatul Cotroceni, cu ocazia concertului susținut de Corul Național de Cameră „Madrigal – Marin Constantin”, alături de corurile Cantus Mundi, pentru medicii implicați în tragedia de la Colectiv și echipa prezidențială, la invitația Președinției României.",
      "Dirijat de Anna Ungureanu, Concertul special de Crăciun al Corului Naţional de Cameră „Madrigal - Marin Constantin” a fost găzduit în Sala Unirii a Palatului Cotroceni din Bucureşti, în prezenţa cadrelor medicale implicate în salvarea şi îngrijirea victimelor tragediei din clubul Colectiv.",
      "Înregistrarea din concertul LIVE cuprinde tradiţionalele colinde de Crăciun, din repertoriul românesc şi internaţional, pe care Madrigalul le interpretează de 52 de ani, neîntrerupt.",
      "Concertul a fost difuzat pe 24 și 25 decembrie pe canalele Televiziunii naționale (TVR1, TVR+ și TVRHD).",
      "Categorie – DVD",
      "O producție a Corului Național de Cameră „Madrigal – Marin Constantin” și a TVR pentru TVR1",
      "An lansare - 2015",
    ],
    image: "concert-extraordinar-de-craciun.jpg",
    price: 40,
  },
  {
    id: 7,
    title: "Muzică Contemporană",
    artist: "Corul Național de Cameră Madrigal",
    conductor: "Marin Constantin",
    playlist: [
      "1. Paul Constantinescu - Pe versuri de Mihai Eminescu - Freamăt de codru 7:38",
      "2. Paul Constantinescu - Pe versuri de Mihai Eminescu - La mijloc de codru des 2:42",
      "3. Paul Constantinescu - Pe versuri de Mihai Eminescu - Peste vârfuri 6:28",
      "4. Paul Constantinescu - Pe versuri de Mihai Eminescu - Stelele-n cer 2:24",
      "5. Pascal Bentoiu - Preludiu Coral la Opera „Hamlet” 6:34",
      "6. Liana Alexandra - Soarele și Luna (Solo: Vladimir Popescu Deveselu) 11:09",
      "7. Laurențiu Profeta - Popas la Mănăstirea Putna 6:11",
      "8. Șerban Nichifor - Valurile, vânturile... pe versuri de Mihai Eminescu (înregistrare din concert) 8:22",
      "9. Liviu Glodeanu – Sabarcalina Suită pentru „Madrigal” și jucării muzicale 4:38",
      "10. Nicolae Bretan - „Rugă” din opera „Horia” (înregistrare din concert) 2:36",
      "11. Mihai Moldovan - Corijențe la canto academic – parodii (înregistrare din concert la Festivalul „George Enescu”, 1988) 7:25",
    ],
    description: [
      "Albumul discografic „Muzică Contemporană” conține o selecție a unora dintre cele mai reprezentative lucrări corale compuse de creatorii români special pentru Corul de Cameră „Madrigal”.",
      "Categorie – CD",
      "Label – Electrecord",
      "Maestru de sunet – Cornelia Andreescu",
      "An lansare – 2008",
      "Cu sprijinul Ministerului Educației, Cercetării și Tineretului",
    ],
    image: "contemporary-music.jpeg",
    price: 29,
  },
  {
    id: 8,
    title: "Christmas with Madrigal - „Romanian Christmas Carols”",
    artist: "”Madrigal” Chamber Choir",
    conductor: "Marin Constantin",
    playlist: [
      "1. T. Popovici: Astăzi s-a născut Hristos 00:53",
      "2. D. G. Kiriac: Nouă azi ne-a rasarit 3:21",
      "3. I. D. Chirescu: Moș Crăciun cu plete dalbe și I. Costescu: Bună dimineața la Moș Ajun 3:18",
      "4. T. Popovici: Trei păstori 2:59",
      "5. G. Cucu: Cetiniță, cetioara 2:42",
      "6. V. Teodorian: Legănelul lui Iisus 2:04",
      "7. I. Borgovan / O. Goga: Moș Crăciun 4:00",
      "8. N. Ursu: Vine Crăciunul pe sară 2:22",
      "9. P. Constantinescu: „Podobia'' din Oratoriul de Craciun 2:37",
      "10. A. Podoleanu / I. D. Chirescu: Bună dimineața la Moș Ajun 00:45",
      "11. T. Brediceanu: Iată vin colindătorii 00:50",
      "12. D.G. Kiriac : O, ce veste minunată și Plecarea magilor 3:56",
      "13. A. Pann - culegere folclor: Trei Crai de la Rasarit 3:00",
      "Soloist: Ștefan Pruteanu",
      "14. S. Dragoi: Colo-n susu 1:05",
      "15. G. Cucu: Domnuleț și Domn din cer 3:35",
      "16. E. Monția: Sus la poarta Raiului și Colindița 2:44",
      "17. I. Chirescu: Steaua sus răsare 1:55",
      "18. N. Lungu: La Vitleem colo-n jos 2:40",
      "19. A. Pann - culegere folclor: La nunta din Cana Galileei 1:58",
      "20. I. Cocișiu: Colinda de păcurar 1:05",
      "21. Fr. Hubic: Floricica 2:54",
      "22. V. Popovici: Velerim și Veler Doamne 1:10",
      "23. V. Popovici: Ziurel de ziuă 1:40",
      "24. G. Cucu: Colindă de Florii 1:40",
      "25. M. Bârcă: Noi umblăm și colindăm 1:13",
      "26. Paul Constantinescu: Condacul nașterii din Oratoriul de Crăciun 1:46",
      "27. T. Popovici: Praznic luminos 2:13",
      "28. I. D. Chirescu: Colo-n umbra pomilor 3:55",
      "29. V. Popovici: Închinarea magilor 1:37",
      "30. N. Ursu: Se preumblă Maica sfântă 2:59",
      "31. Gh. Cucu: Domn, Domn, să-nălțăm 1:18",
      "32. N. Lungu: Mărire-ntru cele-nalte 1:27",
    ],
    description: [
      '„Romanian Christmas Carols” contains the most beautiful carols performed by the "Madrigal" Chamber Choir, conducted by Maestro Marin Constantin.',
      "Category – CD",
      "Label – Electrecord",
      "Sound – Cornelia Andreescu/ Eugen Wendel",
      "Release – 2008",
      "With the support of the Ministry of Ministry of Education, Research and Youth",
    ],
    image: "christmas-with-madrigal.jpg",
    price: 29,
  },
];

export default {
  getProducts(cb) {
    cb(_products);
  },

  buyProducts(products, cb, errorCb) {
    setTimeout(() => {
      // simulate random checkout failure.
      Math.random() > 0.5 || navigator.webdriver ? cb() : errorCb();
    }, 100);
  },
};
